import { TitleSection } from '../../../title-section'
import React from 'react'
import { Tab, Row, Nav, Col } from 'react-bootstrap'

import { FeatureTabContent } from '../../../feature-tab-content'

export const FeatureSection = () => (
  <section id="features" className="features">
    <div className="container">
      <TitleSection title="Features" description="Our Lab Top Features" />

      <Tab.Container id="lab-features-tab" defaultActiveKey="test-upload">
        <Row>
          <Col lg={3}>
            <Nav variant="tabs" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="test-upload">Test results upload</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="custom-reports">Custom reports</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="integrated-db">Integrated database</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col lg={9} className="mt-4 mt-lg-0">
            <Tab.Content>
              <Tab.Pane eventKey="test-upload">
                <FeatureTabContent
                  title="Test results upload"
                  description="No need to remind the plants for the test results. Just upload it! Integrated Plants and Labs, get tests results from Lab to Plant for just a few seconds."
                  featureImage="/assets/img/lab-app/lab-2.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="custom-reports">
                <FeatureTabContent
                  title="Custom Reports"
                  description="Analyze Lab tests results with customizable OLAP report tool. Easy way to filter tests with our pre-made filter template or even filter using a custom filter tool."
                  featureImage="/assets/img/lab-app/lab-1.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="integrated-db">
                <FeatureTabContent
                  title="Integrated Database"
                  subTitle="Automatically associate specific test results to each milk pickups."
                  description="Lab test results are automatically integrated to each milk pickup from payroll."
                  featureImage="/assets/img/lab-app/lab-2.png"
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  </section>
)
